/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Ship } from './Ship';
import {
    ShipFromJSON,
    ShipFromJSONTyped,
    ShipToJSON,
} from './Ship';

/**
 * 
 * @export
 * @interface ShipInfoPostRequest
 */
export interface ShipInfoPostRequest {
    /**
     * 
     * @type {Date}
     * @memberof ShipInfoPostRequest
     */
    time?: Date;
    /**
     * 
     * @type {Ship}
     * @memberof ShipInfoPostRequest
     */
    ship?: Ship;
}

/**
 * Check if a given object implements the ShipInfoPostRequest interface.
 */
export function instanceOfShipInfoPostRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipInfoPostRequestFromJSON(json: any): ShipInfoPostRequest {
    return ShipInfoPostRequestFromJSONTyped(json, false);
}

export function ShipInfoPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipInfoPostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': !exists(json, 'time') ? undefined : (new Date(json['time'])),
        'ship': !exists(json, 'ship') ? undefined : ShipFromJSON(json['ship']),
    };
}

export function ShipInfoPostRequestToJSON(value?: ShipInfoPostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': value.time === undefined ? undefined : (value.time.toISOString()),
        'ship': ShipToJSON(value.ship),
    };
}

